module.exports = __webpack_public_path__ + "img/patient-profile-school.4de34ebd.png";